import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Loader } from 'components';
import { AppConstants, RouteConstants } from 'constant';
import { AppUtils, StorageUtils } from 'utils';

const { STORAGE_VALID_TO } = AppConstants;
const { ROUTE_LOGIN, ROUTE_DASHBOARD } = RouteConstants;

const WelcomePage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const validTo = StorageUtils.getObject(STORAGE_VALID_TO);
    if (!validTo || validTo < new Date().getTime()) {
      AppUtils.logout();
      navigate(ROUTE_LOGIN);
      return;
    }
    navigate(ROUTE_DASHBOARD);
  }, []);

  return <Loader />;
}

export default WelcomePage;